import React from 'react';
import { connect } from 'react-redux';
import { changeUserView, setLayout, toggleFullscreenView, toggleUnsavedViewModal } from '../../../actions';
import { BsGridFill, BsFillGrid3X2GapFill, BsGrid3X3GapFill, BsArrowsFullscreen } from 'react-icons/bs';
import { RiCheckboxBlankFill } from 'react-icons/ri';
import { FcGrid } from 'react-icons/fc';
import grid12 from './grid12.png';

const LiveSideBar = props => {
  const {
    layoutConfig,
    userViews,
    deviceIdList,
    selectedUserView,
    user,
    token,
    editMode,
    changeUserView,
    setLayout,
    toggleFullscreenView,
    toggleUnsavedViewModal,
  } = props;

  const openFullscreen = (e) => {
    toggleFullscreenView()
  }

  const handleViewSelect = (value) => {
    const onClose = () => changeUserView(value, userViews, token, deviceIdList, user.bID)
    if (editMode) {
      toggleUnsavedViewModal(true, onClose)
    } else {
      if (value === 'new') {
        setLayout('16')
      }
      onClose()
    }
  };

  return (
    <>
      <div style={styles.layoutContainer}>
        <div style={{...styles.layoutListItem, backgroundColor: layoutConfig === '1' ? '#38ACEC' : 'lightgrey' }}>
          <RiCheckboxBlankFill style={styles.layoutIcon} onClick={() => { setLayout('1') }} />
        </div>

        <div style={{...styles.layoutListItem, backgroundColor: layoutConfig === '4' ? '#38ACEC' : 'lightgrey' }}>
          <BsGridFill style={styles.layoutIcon} onClick={() => setLayout('4')} />
        </div>

        <div style={{...styles.layoutListItem, backgroundColor: layoutConfig === '6' ? '#38ACEC' : 'lightgrey' }}>
          <BsFillGrid3X2GapFill style={styles.layoutIcon} onClick={() => setLayout('6')} />
        </div>

        <div style={{...styles.layoutListItem, backgroundColor: layoutConfig === '9' ? '#38ACEC' : 'lightgrey' }}>
          <BsGrid3X3GapFill style={styles.layoutIcon} onClick={() => setLayout('9')} />
        </div>

        <div style={{...styles.layoutListItem, backgroundColor: layoutConfig === '12' ? '#38ACEC' : 'lightgrey' }}>
          <img alt="" src={grid12} style={styles.layoutIcon} onClick={() => setLayout('12')}  />
        </div>

        <div style={{...styles.layoutListItem, backgroundColor: layoutConfig === '16' ? '#38ACEC' : 'lightgrey' }}>
          <FcGrid style={styles.layoutIcon} color="black" onClick={() => setLayout('16')} />
        </div>

        <div style={{...styles.layoutListItem, backgroundColor: 'lightgrey' }}>
          <BsArrowsFullscreen style={styles.layoutIcon} color="black" onClick={openFullscreen} />
        </div>
      </div>

      <div style={styles.viewContainer}>
        <div>View</div>
        <select style={styles.selectStyle}
          value={selectedUserView && selectedUserView.id ? {...selectedUserView}.id : 'new'}
          onChange={e => handleViewSelect(e.target.value)}>

          <option disabled value='default'>Select View</option>
          {user.bRole !== 3 && <option value='new'>-- Create New --</option>}

          { userViews && userViews.length > 0
            ? userViews.map( view => (
                <option value={view.id} key={view.id}>{view.label}</option>
              ))
            : <option disabled value='none'>'No Views Available'</option>
          }
        </select>
        {editMode && <button onClick={() => toggleUnsavedViewModal(true, null)} style={styles.button} >Save</button>}
      </div>
    </>
  )
}

const mapStateToProps = state => {
  const { layoutConfig } = state.config;
  const { userViews, deviceIdList, selectedUserView} = state.data;
  const { user, token } = state.auth;
  const { editMode } = state.live;
  return {
    layoutConfig,
    userViews,
    deviceIdList,
    selectedUserView,
    user,
    token,
    editMode,
  }
}

export default connect(mapStateToProps, {changeUserView, setLayout, toggleFullscreenView, toggleUnsavedViewModal})(LiveSideBar);

export const styles = {
  layoutContainer: {
    padding: '20px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '5px',
  },
  layoutListItem: {
    padding: 5,
    width: '6vmin',
    color: 'rgba(0,0,0,0.7)',
    textAlign: 'center',
    borderRadius: 5,
    boxShadow: 'inset 0 0 2px 1px #000000, inset 0 0 6px 1px grey, inset 0 0 8px grey, inset 0 0 12px lightgrey',
  },
  layoutIcon: {
    width: '80%',
    height: 'auto',
    marginTop: 5,
    color: 'black',
    cursor: 'pointer',
  },
  viewContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  selectStyle: {
    width: '100%',
    fontSize: '1.5vmin',
  },
  button: {
    cursor: 'pointer',
  },
}